import React, { ReactNode } from 'react';
import { IconButton as MaterialIconButton } from '@material-ui/core';

import { useStyles } from './IconButton.styles';

type Color = 'inherit' | 'primary' | 'secondary';

export interface Props {
  children: ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  color?: Color;
  disabled?: boolean;
  qaId?: string;
  label?: string;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
}

const IconButton: React.FC<Props> = ({
  children,
  onClick,
  color = 'primary',
  disabled,
  qaId,
  label = 'icon-button',
  type = 'button',
  className,
}: Props) => {
  const classes = useStyles();

  return (
    <MaterialIconButton
      classes={{
        root: classes.root,
        colorPrimary: classes.colorPrimary,
        colorInherit: classes.colorInherit,
        disabled: classes.disabled,
      }}
      onClick={onClick}
      color={color}
      disableRipple={true}
      disabled={disabled}
      data-qa-id={qaId}
      aria-label={label}
      onMouseDown={(e) => e.preventDefault()}
      type={type}
      className={className}
    >
      {children}
    </MaterialIconButton>
  );
};

export default IconButton;
